var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnsubscribeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6712 8.2054C17.5095 9.23932 18.0132 10.5603 18.0132 12C18.0132 12.7897 17.8576 13.5716 17.5554 14.3011C17.2532 15.0307 16.8103 15.6936 16.2519 16.2519C15.6936 16.8103 15.0307 17.2532 14.3011 17.5554C13.5716 17.8576 12.7897 18.0132 12 18.0132H11.9997C10.6144 18.015 9.2742 17.5367 8.20498 16.6645L16.6712 8.2054ZM12 5.98684L12.0003 5.98684C13.3843 5.98508 14.7236 6.46065 15.7945 7.32878L7.33539 15.7879C6.49065 14.7547 5.98684 13.44 5.98684 12C5.98684 10.4052 6.62037 8.87574 7.74806 7.74806C8.87574 6.62037 10.4052 5.98684 12 5.98684ZM4.75 12C4.75 16.0067 8.00105 19.25 12 19.25C13.9228 19.25 15.7669 18.4862 17.1265 17.1265C18.4862 15.7669 19.25 13.9228 19.25 12C19.25 10.0772 18.4862 8.23311 17.1265 6.87348C15.7669 5.51384 13.9228 4.75 12 4.75C10.0772 4.75 8.23311 5.51384 6.87348 6.87348C5.51384 8.23311 4.75 10.0772 4.75 12Z",
    fill: "#475569",
    stroke: "#475569",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsubscribeIcon);
export default __webpack_public_path__ + "static/media/unsubscribe_icon.4f5035372ac3f9724f62e1221f03ddd9.svg";
export { ForwardRef as ReactComponent };